import { Outlet } from "react-router-dom";
import { Automations } from "./Automations";
import AutomationCreateKeyword from "./AutomationCreateKeyword";
import AutomationConstructor from "./AutomationConstructor/AutomationConstructor";

export const adminAutomationsRoutes = [
  {
    path: "automations",
    element: Outlet,
    children: [
      {
        path: "",
        element: Automations,
      },
      {
        path: "create/keyword",
        element: AutomationCreateKeyword,
      },
      {
        path: "create/constructor/:automationID",
        element: AutomationConstructor,
      },
      {
        path: "create/keyword/:automationID",
        element: AutomationCreateKeyword,
      },
    ],
  },
];
